import { Stack } from '@/src/elements/navigation/Stack'

export default () => (
  <Stack screenOptions={{ headerShown: false, presentation: 'modal', animation: 'slide_from_bottom' }} />
)
